import React from 'react'
import { observer } from 'mobx-react-lite'

import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

import { Text } from '@mxenabled/mxui'
import { Delete as DeleteOutlinedIcon } from '@mxenabled/mx-icons'

import { Dialog, useEvent, useGlobalCopyStore, useTransactionStore } from '../../../../../common'

import type { Transaction } from '../../../../../core'

import { useTransactionsUiStore } from '../../../../context/hooks'
import { ON_CLICK_EVENTS } from '../../../../constants/OnClickEvents'

interface DeleteActionProps {
  transaction: Transaction
}

const DeleteAction: React.FC<DeleteActionProps> = ({ transaction }) => {
  const { onEvent } = useEvent()
  const { removeTransaction } = useTransactionStore()
  const { setShouldDisableDrawerScroll } = useTransactionsUiStore()
  const { common: commonCopy, transactions: copy } = useGlobalCopyStore()

  const [open, setOpen] = React.useState(false)
  const handleDelete = async () => {
    await removeTransaction(transaction.guid)
    onEvent(ON_CLICK_EVENTS.ON_TRANSACTION_DELETE_DELETED)
  }

  return (
    <Box className="mx-txn-delete">
      {transaction && (
        <ListItem disableGutters={true} disablePadding={true}>
          <ListItemButton
            onClick={() => {
              onEvent(ON_CLICK_EVENTS.ON_TRANSACTION_DELETE_CLICK)
              setShouldDisableDrawerScroll(true)
              setOpen(true)
            }}
          >
            <ListItemAvatar>
              <Avatar variant="rounded">
                <DeleteOutlinedIcon color="secondary" fontSize="small" />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={copy.manual_transaction_delete_title}
              secondary={copy.manual_transaction_delete_subtitle}
            />
            <ListItemIcon>
              <DeleteOutlinedIcon />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      )}
      <Dialog
        copy={{ title: copy.manual_transaction_delete_title }}
        isOpen={open}
        onClose={() => {
          setShouldDisableDrawerScroll(false)
          setOpen(false)
        }}
        onPrimaryAction={handleDelete}
        onSecondaryAction={() => onEvent(ON_CLICK_EVENTS.ON_TRANSACTION_DELETE_CANCEL)}
        primaryText={commonCopy.delete_button}
        secondaryText={commonCopy.cancel_button}
      >
        <Text variant="subtitle1">{copy.manual_transaction_delete_description}</Text>
      </Dialog>
    </Box>
  )
}

export default observer(DeleteAction)
